// extracted by mini-css-extract-plugin
export default {"root":"documents-no-items_root__rQaty","title":"documents-no-items_title__7HwOJ","subtitle":"documents-no-items_subtitle__3Ly3M","buttons":"documents-no-items_buttons__oM4+r"};